import { render, staticRenderFns } from "./CustomersView.vue?vue&type=template&id=ca21f0fe"
import script from "./CustomersView.vue?vue&type=script&lang=js"
export * from "./CustomersView.vue?vue&type=script&lang=js"
import style0 from "./CustomersView.vue?vue&type=style&index=0&id=ca21f0fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports